import { customElement, property } from 'lit/decorators.js'
import { LitElement } from 'lit'

type Replacements = Record<string, string>

@customElement('zaptic-i18n')
export class I18n extends LitElement {
    @property({ type: String })
    translationKey: string

    @property({ type: Object })
    replacements: Replacements

    render() {
        return window.i18n(this.translationKey, this.replacements)
    }
}
